import React, { useState } from "react";
import "./Header.css";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartShopping,
  faHeart,
  faMagnifyingGlass,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import Gray_Btn from "../common-components/common_btn/gray_btn/Gray_Btn";

function Header() {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false); // state to control navbar toggle

  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <>
      <section className="main_head">
        <div className="container-md p-0">
          <div className="topdiv">
            <div className="row">
              <div className="col-6">
                <a className="contact-anchor" href="tel:+916262171723">
                  <p className="contp">Contact Us: +91 6262171723</p>
                </a>
              </div>
              {/* <div className="col-6 text-end">
                <div className="d-flex justify-content-end align-items-center iconsdiv">
                  <p className="contp">Follow Us:</p>
                  <Link to="https://www.facebook.com" target="_blank"><img className="soc-icn" src={process.env.PUBLIC_URL + '/assets/images/icons/facebook.png'} /></Link>
                  
                  <Link to="https://www.instagram.com" target='_blank'><img className="soc-icn" src={process.env.PUBLIC_URL + '/assets/images/icons/instagram.png'} /></Link>

                </div>
              </div> */}
            </div>
          </div>
        </div>

        <div className="container-fluid p-0">
          <div className="container-md p-0">
            <Navbar expand="lg" expanded={expanded} onToggle={setExpanded}>
              <Navbar.Brand href="#home">
                <div className="logodiv">
                  <Link to="/">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/assets/images/logo/logo2.png"
                      }
                      alt="Logo"
                      className="logo-img"
                    />
                  </Link>
                </div>
              </Navbar.Brand>

              <div className="mobile_btn_holder">
                <Link target="_blank" to="https://play.google.com/store/apps/details?id=com.loconex.app">
                  <Gray_Btn btn_name="Download App" />
                </Link>
              </div>

              <Navbar.Toggle aria-controls="basic-navbar-nav" />

              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="">
                  <Nav.Link
                    as={Link}
                    to="/"
                    className={location.pathname === "/" ? "active" : ""}
                    onClick={handleNavClick}
                  >
                    Home
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    className={
                      location.pathname === "/about-us" ? "active" : ""
                    }
                    onClick={handleNavClick}
                  >
                    About Us
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/become-seller"
                    className={
                      location.pathname === "/become-seller" ? "active" : ""
                    }
                    onClick={handleNavClick}
                  >
                    Become Seller
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/contact-us"
                    className={
                      location.pathname === "/contact-us" ? "active" : ""
                    }
                    onClick={handleNavClick}
                  >
                    Contact Us
                  </Nav.Link>
                </Nav>

                <div className="desktop_btn_holder">
                  <Link target="_blank" to="https://play.google.com/store/apps/details?id=com.loconex.app">
                    <Gray_Btn btn_name="Download App" />
                  </Link>
                </div>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
      </section>
    </>
  );
}

export default Header;
